import { useUserStore } from "@/store/modules/user";

const AdminHomepage = () => import("@/components/atm-front/admin/AdminHomepage.vue");
const MaterialsAdmin = () => import("@/components/atm-front/admin/MaterialsAdmin.vue");

const privilegedAccess = async (to, from, next) => {
  const userStore = useUserStore();

  const user = userStore.currentUser;
  if (user.isAdmin() || user.isMaterialManager()) {
    next();
  } else {
    next({ name: "admin" });
  }
};

export default [
  {
    path: "",
    name: "admin",
    component: AdminHomepage,
    redirect: { name: "materialsAdmin" },
    children: [
      {
        path: "materials",
        name: "materialsAdmin",
        component: MaterialsAdmin,
      },
    ],
    beforeEnter: privilegedAccess,
  },
];
